var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33,
  _t34,
  _t35,
  _t36,
  _t37,
  _t38,
  _t39,
  _t40;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.string.includes.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from '../../common/sport/translations';
import css from './style.pcss';
import groupBy from "lodash/groupBy";
import { helper } from "../../common/helper";
import PauseButtonIcon from "../../common/images/btn_pause.svg";
import ReplayButtonIcon from "../../common/images/btn_replay.svg";
import TickerButtonIcon from "../../common/images/btn_ticker.svg";
import LiveButtonIcon from "../../common/images/btn_live.svg";
import LiveTickerButtonIcon from "../../common/images/btn_liveticker.svg";
import LiveArenaButtonIcon from "../../common/images/btn_livearena.svg";
import HighlightsButtonIcon from "../../common/images/btn_highlights.svg";
import PlaceholderLogoImage from "../../common/images/logo_placeholder.svg";
import DefaultPlayerImage from "./images/football-player.png";
var RTLSportTeam = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportTeam, _LitElement);
  function RTLSportTeam() {
    var _this;
    _classCallCheck(this, RTLSportTeam);
    _this = _callSuper(this, RTLSportTeam);
    _this.language = 'lu';
    _this.livearena_sports = [1, 2, 3, 4];
    _this.show = "";
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
    }
    return _this;
  }
  _createClass(RTLSportTeam, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportTeam.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      if (!this.id) return;
      this.location = window.location.origin;
      if (process.env.NODE_ENV == 'development') {
        this.location = "http://localhost:8080";
      }
      var apiUrl = "https://api-gate.rtl.lu/sport";
      apiUrl += '/teams/' + this.id + '?lang=' + this.language;
      fetch(apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        _this2.link = _this2._getLink();
        console.log(_this2.data);
      });
    }
  }, {
    key: "_getLink",
    value: function _getLink() {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.sport)}`;
      return link;
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_renderLegendBySport",
    value: function _renderLegendBySport(sport) {
      switch (sport) {
        case 1:
          return html(_t || (_t = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-1_short'), this._getTranslation('aborted-1'), this._getTranslation('postponed-1_short'), this._getTranslation('postponed-1'), this._getTranslation('penalty-1_short'), this._getTranslation('penalty-1'), this._getTranslation('overtime-1_short'), this._getTranslation('overtime-1'), this._getTranslation('forfait-1_short'), this._getTranslation('forfait-1'));
        case 2:
          return html(_t2 || (_t2 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-2_short'), this._getTranslation('aborted-2'), this._getTranslation('postponed-2_short'), this._getTranslation('postponed-2'), this._getTranslation('overtime-2_short'), this._getTranslation('overtime-2'), this._getTranslation('forfait-2_short'), this._getTranslation('forfait-2'));
        case 3:
          return html(_t3 || (_t3 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-3_short'), this._getTranslation('aborted-3'), this._getTranslation('postponed-3_short'), this._getTranslation('postponed-3'), this._getTranslation('penalty-3_short'), this._getTranslation('penalty-3'), this._getTranslation('overtime-3_short'), this._getTranslation('overtime-3'), this._getTranslation('forfait-3_short'), this._getTranslation('forfait-3'));
        case 4:
        case 5:
          return html(_t4 || (_t4 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-3_short'), this._getTranslation('aborted-3'), this._getTranslation('postponed-3_short'), this._getTranslation('postponed-3'), this._getTranslation('forfait-3_short'), this._getTranslation('forfait-3'));
      }
    }
  }, {
    key: "_showPlayer",
    value: function _showPlayer(e, id) {
      if (this.sport !== 1) return;
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.sport)}/resultater`;
      document.location.href = `${link}/teams/player?c=${this.competition}&p=${id}`;
    }
  }, {
    key: "_showLiveticker",
    value: function _showLiveticker(e, matchid, has_details, live_arena_id, live_arena_hidden) {
      var summary = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (!has_details && !live_arena_id) return;
      var add2url = "";
      if (summary) add2url = "&summary=1";
      document.location.href = `${this.link}/match?m=${matchid}${add2url}`;
    }
  }, {
    key: "_tableRow",
    value: function _tableRow(match) {
      var _this3 = this;
      var icon;
      if (match.is_paused) {
        icon = html(_t5 || (_t5 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), PauseButtonIcon);
      } else {
        if (match.was_played && match.live_arena_id && match.has_details && !match.live_arena_hidden) icon = html(_t6 || (_t6 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), ReplayButtonIcon);
        if (match.was_played && match.has_details && (match.live_arena_hidden || match.live_arena_id === null)) icon = html(_t7 || (_t7 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), TickerButtonIcon);
        if (match.is_live && match.live_arena_id) icon = html(_t8 || (_t8 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveButtonIcon);
        if (match.is_live && !match.live_arena_id) icon = html(_t9 || (_t9 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveTickerButtonIcon);
        if (!match.was_played && !match.has_details && !match.is_live && match.live_arena_id && !match.live_arena_hidden) icon = html(_t10 || (_t10 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveArenaButtonIcon);
      }
      var home_logo, visitor_logo;
      var iconSummary;
      if (match.live_arena_summary_url) iconSummary = html(_t11 || (_t11 = _`<img class="results-table__button-highlights" src="${0}" alt="button more"/>`), HighlightsButtonIcon);
      if (this.livearena_sports.includes(this.sport)) {
        home_logo = html(_t12 || (_t12 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
          return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
        }, PlaceholderLogoImage);
        visitor_logo = html(_t13 || (_t13 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
          return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
        }, PlaceholderLogoImage);
      }
      if (match.home_team.logo_url) home_logo = html(_t14 || (_t14 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, match.home_team.logo_url, this.version);
      if (match.visitor_team.logo_url) visitor_logo = html(_t15 || (_t15 = _`<td class="results-table__team2-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, match.visitor_team.logo_url, this.version);
      var sets = [];
      if (match.sets) {
        match.sets.map(function (set) {
          sets.push(html(_t16 || (_t16 = _`
                                <span>${0}:${0}</span>
                            `), set[0], set[1]));
        });
      }
      return html(_t17 || (_t17 = _`
            <tr><td colspan="6" class="results-table__matchdate">${0} - ${0}</td></tr>
            <tr class="results-table__match${0}${0}${0}">

            ${0}
            <td class="results-table__team1" @click=${0}>
                ${0}

            </td>
            <td class="results-table__score" @click=${0}>
                <span class="results-match__scoretext">${0} : ${0}</span>
                ${0}
                ${0}
            </td>
            <td class="results-table__team2" @click=${0}>
                ${0}

            </td>
            ${0}
            ${0}
            </tr>
        `), dayjs(match.date).format('DD/MM/YY'), match.hour, match.has_details || match.live_arena_id && !match.live_arena_hidden ? ' results-table__match--is-clickable' : '', match.is_live ? ' results-table__match--islive' : '', !this.showLogos ? ' results-table__match--nologos' : '', home_logo, function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, this.type === 'main' ? html(_t18 || (_t18 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.home_team.name, match.home_team.short_name) : match.home_team.short_name ? match.home_team.short_name : match.home_team.name, function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, match.home_score, match.visitor_score, match.info !== 'date_unknown' && match.info ? html(_t19 || (_t19 = _`<span class="results-match__info">${0}</span>`), this._getTranslation(match.info + '-' + this.sport + '_short')) : '', sets.length > 0 ? html(_t20 || (_t20 = _`<span class="results-match__sets">${0}</span>`), sets) : '', function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, this.type === 'main' ? html(_t21 || (_t21 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.visitor_team.name, match.visitor_team.short_name) : match.visitor_team.short_name ? match.visitor_team.short_name : match.visitor_team.name, visitor_logo, icon ? html(_t22 || (_t22 = _`
                <td class="results-table__button-more-container">
                    <span @click=${0}>${0}</span>
                    <span @click=${0}>${0}</span>
                </td>
            `), function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden);
      }, icon, function (e) {
        return _this3._showLiveticker(e, match.id, match.has_details, match.live_arena_id, match.live_arena_hidden, true);
      }, iconSummary) : html(_t23 || (_t23 = _`<td class="results-table__button-more-container"></td>`)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.data === undefined) return html(_t24 || (_t24 = _`Loading...`));

      // let showArray = this.show.split(',');
      // if (showArray[0] === "") {
      //     if (this.sport === 1) {
      //         showArray = ['team', 'kader', 'spillplang'];
      //     } else {
      //         showArray = ['team', 'spillplang'];
      //     }
      // }
      var showArray = ['team', 'kader', 'spillplang'];
      var matches = this.data.matches;
      var team = this.data.team;
      var players = this.data.players;
      var competitions = this.data.competitions;
      var image = '';
      if (team.team_image_url) image = html(_t25 || (_t25 = _`<img class="sport-team-img" src="${0}"/>`), team.team_image_url);
      var logo = '';
      if (team.logo_url) logo = html(_t26 || (_t26 = _`<img class="sport-team__logo-team" src="${0}" />`), team.logo_url);
      var rounds = this.data.rounds;
      var competition = this.data.competition;
      var filteredResults = groupBy(this.data.matches, function (match) {
        return match.competition.name;
      });
      var tableRows = [];
      var table;
      var i = 0;
      for (var key in filteredResults) {
        if (i > 0) {
          tableRows.push(html(_t27 || (_t27 = _`
                    <tr>
                        <td className="results-table__spacer"></td>
                    </tr>
                `)));
        }
        tableRows.push(html(_t28 || (_t28 = _`
                <tr>
                    <th colspan="6" class="results-table__comp">${0}</th>
                </tr>
            `), key));
        if (filteredResults.hasOwnProperty(key)) {
          tableRows.push(filteredResults[key].map(function (match) {
            return _this4._tableRow(match);
          }));
        }
        i++;
      }
      table = html(_t29 || (_t29 = _`<table class="results-table">${0}</table>`), tableRows);
      var nextMatch;
      var nextMatchRow = [];
      if (this.data.next_match) {
        nextMatchRow.push(this._tableRow(this.data.next_match));
        nextMatch = html(_t30 || (_t30 = _`<h1 class="sport__title">${0}</h1><table class="results-table">${0}</table>`), this._getTranslation('next_match'), nextMatchRow);
      }
      return html(_t31 || (_t31 = _`
            <style>${0}</style>

            <div class="sport-team__container">
                ${0}

                ${0}

                ${0}
            </div>
        `), css, showArray.includes('team') ? html(_t32 || (_t32 = _`
                    <div class="sport-team__img-name">
                        <div class="sport-team__name-container">
                            ${0}
                            <h1 class="sport-team__name-team">${0}
                                <span>
                                ${0}
                            </span>
                            </h1>
                        </div>
                        ${0}
                    </div>
                `), logo, team.name, competitions.map(function (items) {
        return html(_t33 || (_t33 = _`
                                    <b>${0}</b>
                                `), items.name);
      }), image) : '', showArray.includes('kader') ? html(_t34 || (_t34 = _`
                    <div class="sport-team__wrapper">
                        ${0}
                    </div>
                `), players.length > 0 ? html(_t35 || (_t35 = _`
                        <div class="sport-team-players">
                            <h1 class="sport__title">${0}</h1>
                            ${0}
                        </div>
                        `), this._getTranslation('players'), players.map(function (items) {
        return html(_t36 || (_t36 = _`
                                ${0}

                                <div class="sport-team-player-container">
                                ${0}
                                </div>
                            `), items.players.length > 0 ? html(_t37 || (_t37 = _`<h2 class="sport-team__type-players">${0}</h2>`), _this4._getTranslation(items.type)) : "", items.players.map(function (player) {
          var playerImg = `${DefaultPlayerImage}`;
          if (player.image_url) playerImg = player.image_url;
          var hasLink = _this4.sport === 1;
          return html(_t38 || (_t38 = _`
                                        <div class="sport-team-player">
                                            <div class="sport-team-player-card" @click=${0} style="cursor: ${0}">
                                                <img class="sport-team-player__image" src="${0}" alt="${0}" width="70" height="70" />
                                                <span class="sport-tem-player__number">${0}</span>
                                                <span class="sport-team-player__name">${0} <b>${0}</b></span>
                                                ${0}
                                            </div>
                                        </div>
                                    `), function (e) {
            return _this4._showPlayer(e, player.id);
          }, hasLink ? "pointer" : "default", helper.stockify(playerImg, 70), player.formatted_name, player.number, player.first_name, player.last_name, player.nationalities.map(function (nationality) {
            return html(_t39 || (_t39 = _`
                                                    <span class="sport-team-player__nationality"><img src="${0}/images/flags-alt/${0}.svg" height="12"></span>
                                                `), _this4.assetsUrl, nationality.code.toLowerCase());
          }));
        }));
      })) : ``) : '', showArray.includes('spillplang') ? html(_t40 || (_t40 = _`
                    <div class="sport-team-matches">
                        ${0}
                        <h1 class="sport__title">${0}</h1>
                        ${0}
                        ${0}
                    </div>
                `), nextMatch, this._getTranslation('matches'), table, this._renderLegendBySport(this.data.sport.id)) : '');
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        id: {
          type: Number
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        language: {
          type: String
        },
        show: {
          type: String
        }
      };
    }
  }]);
  return RTLSportTeam;
}(LitElement);
export { RTLSportTeam as default };
window.customElements.define('rtl-sport-team', RTLSportTeam);